<template>
  <el-dialog width="1200px" title="Ownership Role History" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div class="pb20">
      <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column align="center" label="Handling Time" width="164px">
          <template slot-scope="scope">
            {{ scope.row.createAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="From">
          <template slot-scope="scope">
            <p v-if="scope.row.from">{{ scope.row.from.nickname || scope.row.from.username }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="To">
          <template slot-scope="scope">
            <p v-if="scope.row.to">{{ scope.row.to.nickname || scope.row.to.username }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Type">
          <template slot-scope="scope">
            <p>{{ ownershipTypeFormat(scope.row.type) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Ownership Role">
          <template slot-scope="scope">
            <p>{{ ownershipRoleFormat(scope.row.ownershipRole) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Operator">
          <template slot-scope="scope">
            <p>{{ scope.row.operator.nickname || scope.row.operator.username }}</p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [paginationMixin, filtersMixin, formatterMixin],
  props: {
    applymentId: {
      type: String,
    },
  },
  components: { Pagination },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
    };
  },
  methods: {
    async init() {
      this.visible = true;
      await this.$nextTick();
      this.getDataList(1);
    },
    // 获取分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const { code, data } = await this.$http.get("/admin/companyApplymentOwnershipLog/paging", {
        params: {
          current: this.current,
          size: this.pageSize,
          "orders[0].asc": false,
          "orders[0].column": "id",
          applymentId: this.applymentId,
        },
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
  },
};
</script>
